import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlusSignComponent } from './plus-sign.component';

@NgModule({
  declarations: [
    PlusSignComponent
  ],
  imports: [
    CommonModule
  ], exports:[
    PlusSignComponent
  ]
})
export class PlusSignSvgModule { }
